import { HttpEventType } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { CreateContactDto } from 'src/app/components/user-dashboard/contacts/create/dto/create-contact.dto';
import { GlobalWizardSettings } from 'src/app/components/user-dashboard/portal/dto/portal.input';
import { WebsiteIdentity } from 'src/app/components/user-dashboard/portal/portal.model';

import {
  WizardModel,
  WizardStepStatusEnum,
  StepVisibilityEnum,
  WizardTypeEnum,
} from 'src/app/models/wizard';
import { ApiService, MediaUploadService, CourseAiFieldHistoryService } from 'src/app/shared/services';
import { isAccountSetupStepsDone } from 'src/app/shared/store/_features/account-setup/account-setup.selector';
import {
  NewContactActions,
  UpdateContactActions,
} from 'src/app/shared/store/_features/contacts/contacts.actions';
import { OnboardingActions } from 'src/app/shared/store/_features/user/auth/auth.actions';
import { updateWebsiteIdentity } from 'src/app/shared/store/_features/website/website.actions';
import { COLOR_PALETTES } from './steps/hub-branding-step/color-palette-selector/color-palette-selector.component';

export type WebsiteIdeaStepKey = 'idea' | 'audience' | 'goals';
export enum WebsiteIdeaStepStatusEnum {
  done = 'done',
  inProgress = 'inProgress',
  notStarted = 'notStarted',
}

interface WebsiteIdeaStepConfig {
  key: WebsiteIdeaStepKey;
  label: string;
  status: WebsiteIdeaStepStatusEnum;
}

export enum OnboardingWizardSetupStepsEnum {
  welcome = 'welcome',
  hub_vision = 'hub_vision',

  hub_idea_1 = 'hub_idea_1',
  hub_idea_2 = 'hub_idea_2',
  hub_idea_3 = 'hub_idea_3',

  hub_identity = 'hub_identity',
  hub_branding = 'hub_branding',
  hub_instructor = 'hub_instructor',
  hub_business_legal = 'hub_business_legal',
  hub_home_banner = 'hub_home_banner',
  completion = 'completion',
  // logo_setup = 'logo_setup',
  // theme_colors = 'theme_colors',
  instructor_profile = 'instructor_profile',
  instructor_bio = 'instructor_bio',
  business_legal = 'business_legal',
  home_banner = 'home_banner',
  finalizing = 'finalizing',
}

@Injectable({
  providedIn: 'root',
})
export class AccountSetupHelperService {
  baseGradientColors: string[] = [
    'rgba(20, 186, 203, 0.5)',
    'rgba(57, 122, 241, 0.83)',
    'rgba(176, 102, 205, 0.93)',
    'rgba(247, 82, 120, 0.5)',
    'rgba(245, 95, 92, 0.5)',
  ];
  animationMode: 'thinking' | 'writing' | 'idle' = 'thinking';
  aiLoaderMessage: string = '';

  wizardSettings: GlobalWizardSettings = {
    portalType: null,
    summaryAnimation: null,
    finalStepLabel: 'Create',
  };
  public wizardModel: WizardModel;
  wizardData = {
    hubInput: {
      aiState: {
        aiSeed: '',
        aiData: {
          idea: ``,
          audience: ``,
          goals: ``,
        },
      },
      hubIdentity: {
        name: '',
        subDomain: '',
        domain: '',
        tagline: '',
      },
      hubBranding: {
        colorPalette: null,
        logoMode: 'none',
        placeHolderLogo: null,
        logo: [],
        logo_id: [],
      },
      hubInstructor: {
        fullName: '',
        title: '',
        email: '',
        bio: '',
        image: [],
        image_id: [],
      },
      hubBusinessLegalDetails: {
        contactEmail: '',
        businessAddress: ``,
        refundPeriod: '14',
        customDays: '',
      },
      hubHomePageBanner: {
        image: [],
        image_id: [],
        currentHistoryIndex: -1,
        generationHistory: [],
      },
    },

    // hubInput: {
    //   aiState: {
    //     aiSeed: "Teaching",
    //     aiData: {
    //       idea: "The Teaching Hub is an online academy that offers a wide range of courses, from basic to advanced, in various subjects like mathematics, science, literature, and art, all taught by expert educators. Visitors can also find a forum where they can connect with fellow learners and teachers to exchange ideas and solutions.",
    //       audience: "The ideal target learners for a teaching hub would be individuals aged 18 to 35, with a diverse educational and professional background, who are eager to enhance their teaching skills, incorporate innovative pedagogical techniques, and face challenges such as adapting to different learning styles and integrating technology into the classroom.",
    //       goals: "The main objective of a hub focused on teaching is to provide learners with a comprehensive and versatile learning experience. This can be achieved by offering a wide range of educational resources, such as videos, articles, and interactive quizzes, designed to cater to different learning styles and preferences. By doing so, the hub aims to make learning accessible and engaging for all students, regardless of their background or skill level. In addition to providing educational content, the hub should also foster a sense of community among learners. By encouraging discussion, collaboration, and peer-to-peer support, the hub can help learners develop essential social and communication skills, which are crucial for success in both personal and professional contexts. Ultimately, the value of this hub lies in its ability to empower learners with the knowledge, skills, and confidence needed to achieve their full potential and make a positive impact on the world."
    //     }
    //   },
    //   hubIdentity: {
    //     name: "TeachInnovate",
    //     subDomain: "teachinnovate",
    //     domain: "teachinnovate.learmosites.dev",
    //     tagline: "Empowering Educators to Transform Learning"
    //   },
    //   hubBranding: {
    //     colorPalette: {
    //       id: 2,
    //       name: "Ocean Depths",
    //       colors: [
    //         "#B2F5EA",
    //         "#81E6D9",
    //         "#4FD1C5",
    //         "#38B2AC",
    //         "#285E61"
    //       ]
    //     },
    //     logoMode: "placeholder",
    //     logo: [],
    //     logo_id: []
    //   },
    //   hubInstructor: {
    //     fullName: "hello emy",
    //     title: "Instructor",
    //     bio: "Hello Emy is an enthusiastic and dedicated instructor at the hub. With a passion for teaching and a deep understanding of the subject matter, she creates an engaging and supportive learning environment for her students. Her ability to explain complex concepts in a clear and concise manner has made her a favorite among both seasoned learners and beginners.",
    //     image: [],
    //     image_id: []
    //   },
    //   hubBusinessLegalDetails: {
    //     contactEmail: "contact@learmosites.dev",
    //     businessAddress: "12 El-Mansoura St, Giza, Egypt",
    //     refundPeriod: "7",
    //     customDays: ""
    //   },
    //   hubHomePageBanner: {
    //     image: [],
    //     image_id: []
    //   }
    // },
    temp: new Object(),
  };
  accountSetupData: any = {
    vision: null,
  };

  readonly WebsiteIdeaSteps: WebsiteIdeaStepConfig[] = [
    {
      key: 'idea',
      label: 'Idea',
      status: WebsiteIdeaStepStatusEnum.notStarted,
    },
    {
      key: 'audience',
      label: 'Audience',
      status: WebsiteIdeaStepStatusEnum.notStarted,
    },
    {
      key: 'goals',
      label: 'Goals',
      status: WebsiteIdeaStepStatusEnum.notStarted,
    },
  ];

  ownerContactId: number;

  constructor(
    private apiService: ApiService,
    private store: Store,
    private mediaUpload: MediaUploadService,
    private toastr: ToastrService,
    private historyService: CourseAiFieldHistoryService,
  ) {
    this.fetchOwnerContact();
  }

  fetchOwnerContact() {
    this.apiService
      .getContacts({ dummy: false, type: 'owner' })
      .subscribe((contacts: any[]) => {
        if (contacts && contacts.length > 0) {
          const owner = contacts[0];
          this.ownerContactId = owner.id;
          this.wizardData.hubInput.hubInstructor.fullName = owner.name;
          // If we wanted to pre-fill other fields like bio/title if they exist on the owner contact, we could do it here
        }
      });
  }

  changeColorsForDuration(colors: string[], duration = 2500) {
    const tempDefaultValue = [...this.baseGradientColors];
    this.baseGradientColors = colors;
    setTimeout(() => {
      this.baseGradientColors = tempDefaultValue;
    }, duration);
  }

  setAiLoaderState(
    animationMode: 'thinking' | 'writing' | 'idle' = 'thinking',
  ) {
    this.animationMode = animationMode;
  }

  setAiLoaderMessage(message: string, displayFor: number = 0) {
    this.aiLoaderMessage = message;
    if (displayFor > 0) {
      setTimeout(() => {
        this.aiLoaderMessage = '';
      }, displayFor);
    }
  }

  // Wizard Initial
  initializeWizardProductCreate() {
    this.historyService.clearHistory();
    this.wizardSettings.finalStepLabel = 'Create My Product';
    this.wizardModel = new WizardModel(
      [
        {
          id: 1,
          title: 'Welcome',
          description: 'Welcome to Learmo',
          status: WizardStepStatusEnum.none,
          enumTag: OnboardingWizardSetupStepsEnum.welcome,
          visibility: StepVisibilityEnum.visible,
          isValid: true,
          hideButtons: {
            back: true,
            next: false,
          },
          hideSteps: true,
          navigationAction: () => {
            this.navigationAction();
          },
          nextButtonLabel: 'Choose to continue',
        },
        {
          id: 2,
          title: 'Hub Vision',
          description: 'Describe your hub',
          status: WizardStepStatusEnum.dummy,
          visibility: StepVisibilityEnum.visible,
          isValid: false,
          validate: this.hubVisionValidator,
          enumTag: OnboardingWizardSetupStepsEnum.hub_vision,
          hideButtons: {
            back: false,
            next: false,
          },
          navigationAction: () => {
            this.navigationAction();
          },
        },
        {
          id: 31,
          title: 'Hub Idea 1 (Idea',
          description: 'Ai generated',
          status: WizardStepStatusEnum.dummy,
          visibility: StepVisibilityEnum.visible,
          isValid: false,
          validate: this.hubIdeaValidator,
          enumTag: OnboardingWizardSetupStepsEnum.hub_idea_1,
          hideButtons: {
            back: false,
            next: false,
          },
          navigationAction: () => {
            this.navigationAction();
          },
        },
        {
          id: 32,
          title: 'Hub Idea 2 (Audience)',
          description: 'Ai generated',
          status: WizardStepStatusEnum.dummy,
          visibility: StepVisibilityEnum.visible,
          isValid: false,
          validate: this.hubAudienceValidator,
          enumTag: OnboardingWizardSetupStepsEnum.hub_idea_2,
          hideButtons: {
            back: false,
            next: false,
          },
          navigationAction: () => {
            this.navigationAction();
          },
        },
        {
          id: 33,
          title: 'Hub Idea 3 (Goals)',
          description: 'Ai generated',
          status: WizardStepStatusEnum.dummy,
          visibility: StepVisibilityEnum.visible,
          isValid: false,
          validate: this.hubGoalsValidator,
          enumTag: OnboardingWizardSetupStepsEnum.hub_idea_3,
          hideButtons: {
            back: false,
            next: false,
          },
          navigationAction: () => {
            this.navigationAction();
          },
        },
        {
          id: 4,
          title: 'Hub Identity',
          description: 'Ai generated',
          status: WizardStepStatusEnum.dummy,
          visibility: StepVisibilityEnum.visible,
          isValid: false,
          validate: this.hubIdentityValidator,
          enumTag: OnboardingWizardSetupStepsEnum.hub_identity,
          hideButtons: {
            back: false,
            next: false,
          },
          navigationAction: () => {
            this.navigationAction();
          },
        },
        {
          id: 5,
          title: 'Hub Branding',
          description: 'Ai generated',
          status: WizardStepStatusEnum.dummy,
          visibility: StepVisibilityEnum.visible,
          isValid: false,
          validate: this.hubBrandingValidator,
          enumTag: OnboardingWizardSetupStepsEnum.hub_branding,
          hideButtons: {
            back: false,
            next: false,
          },
          navigationAction: () => {
            this.navigationAction();
          },
        },
        {
          id: 6,
          title: 'Hub Instructors',
          description: 'Ai generated',
          status: WizardStepStatusEnum.dummy,
          visibility: StepVisibilityEnum.visible,
          isValid: true,
          enumTag: OnboardingWizardSetupStepsEnum.hub_instructor,
          hideButtons: {
            back: false,
            next: false,
          },
          navigationAction: () => {
            this.navigationAction();
          },
        },
        {
          id: 7,
          title: 'Hub Legal Business Details',
          description: 'Ai generated',
          status: WizardStepStatusEnum.dummy,
          visibility: StepVisibilityEnum.visible,
          isValid: true,
          enumTag: OnboardingWizardSetupStepsEnum.hub_business_legal,
          hideButtons: {
            back: false,
            next: false,
          },
          navigationAction: () => {
            this.navigationAction();
          },
        },
        {
          id: 8,
          title: 'Hub Home Banner',
          description: 'Ai generated',
          status: WizardStepStatusEnum.dummy,
          visibility: StepVisibilityEnum.visible,
          isValid: true,
          enumTag: OnboardingWizardSetupStepsEnum.hub_home_banner,
          nextButtonLabel: 'Finish',
          hideButtons: {
            back: false,
            next: false,
          },
          navigationAction: () => {
            this.navigationAction();
          },
        },
        {
          id: 9,
          title: 'Completion',
          description: 'Ai generated',
          status: WizardStepStatusEnum.dummy,
          visibility: StepVisibilityEnum.visible,
          isValid: true,
          enumTag: OnboardingWizardSetupStepsEnum.completion,
          hideButtons: {
            back: true,
            next: true,
          },
          navigationAction: () => {
            this.navigationAction();
          },
        },
      ],
      0,
      WizardTypeEnum.accountSetup,
      this.backAction,
      this.completeAccountSetup,
    );
    //
  }

  hubVisionValidator = () => {
    return !!this.wizardData?.hubInput?.aiState?.aiSeed;
  };

  hubIdeaValidator = () => {
    return !!this.wizardData?.hubInput?.aiState?.aiData?.idea;
  };

  hubAudienceValidator = () => {
    return !!this.wizardData?.hubInput?.aiState?.aiData?.audience;
  };

  hubGoalsValidator = () => {
    return !!this.wizardData?.hubInput?.aiState?.aiData?.goals;
  };

  hubIdentityValidator = () => {
    return (
      !!this.wizardData?.hubInput?.hubIdentity?.name &&
      !!this.wizardData?.hubInput?.hubIdentity?.subDomain &&
      !!this.wizardData?.hubInput?.hubIdentity?.tagline
    );
  };

  hubBrandingValidator = () => {
    return !!this.wizardData?.hubInput?.hubBranding?.colorPalette;
  };

  navigationAction = () => {};

  backAction = () => {
    // this.router.navigate(['dashboard', 'product']);
  };

  completeAccountSetup = () => {
    this.store.dispatch(OnboardingActions.markWebsiteSetupDone());
  };

  async uploadLogo(base64Image: string): Promise<any> {
    const file = this.mediaUpload.base64ToFile(base64Image, 'site-logo.png');

    return new Promise((resolve, reject) => {
      this.mediaUpload.uploadFile(file, 'media').subscribe({
        next: (event) => {
          if (event.type === HttpEventType.Response) {
            this.wizardData.hubInput.hubBranding.logo_id =
              event.body.uploadedFiles.map((file) => file.id);
            resolve(1);
          }
        },
        error: () => {
          this.toastr.error('Logo Upload failed.');
          reject();
        },
      });
    });
  }
  // Wizard Final Actions
  updateWebsiteIdentity = async () => {
    if (
      this.wizardData.hubInput.hubBranding.placeHolderLogo &&
      this.wizardData.hubInput.hubBranding.logo_id.length === 0
    ) {
      await this.uploadLogo(
        this.wizardData.hubInput.hubBranding.placeHolderLogo,
      );
    }
    this.wizardData.hubInput;
    const payload: WebsiteIdentity = {
      title: this.wizardData.hubInput.hubIdentity.name,
      description: this.wizardData.hubInput.hubIdentity.tagline,
      logo_id:
        this.wizardData.hubInput.hubBranding.logo_id.length > 0
          ? this.wizardData.hubInput.hubBranding.logo_id
          : undefined,
      color_palette: this.wizardData.hubInput.hubBranding.colorPalette,
      legal_business_details: this.wizardData.hubInput.hubBusinessLegalDetails,
      ai_state: this.wizardData.hubInput.aiState,
      label: this.wizardData.hubInput.hubIdentity.name,
      page_initial_data: {
        homeBanner: {
          image_id: this.wizardData.hubInput.hubHomePageBanner.image_id,
        },
      },
    };

    let instructorPayload: CreateContactDto = {
      name: this.wizardData.hubInput.hubInstructor.fullName,
      title: this.wizardData.hubInput.hubInstructor.title,
      bio: this.wizardData.hubInput.hubInstructor.bio,
      type: 'instructor',
      avatar:
        this.wizardData.hubInput.hubInstructor.image_id.length > 0
          ? this.wizardData.hubInput.hubInstructor.image_id[0]
          : undefined,
    };

    this.store.dispatch(updateWebsiteIdentity.update({ identity: payload }));

    if (this.ownerContactId) {
      this.store.dispatch(
        UpdateContactActions.update({
          itemId: this.ownerContactId,
          item: instructorPayload,
          contactType: 'owner',
        }),
      );
    } else {
      this.store.dispatch(
        NewContactActions.create({ createPayload: instructorPayload }),
      );
    }

    this.store.dispatch(
      updateWebsiteIdentity.updateSubDomain({
        domain: this.wizardData.hubInput.hubIdentity.subDomain,
        silent: true,
      }),
    );

    // this.loadingCreate = true;
    // this.store.select(selectProductsState).pipe(takeWhile(state => state?.createNewProductProcess.status !== 'done' && state?.createNewProductProcess.status !== 'error', true)).subscribe(state => {
    //   switch (state?.createNewProductProcess.status) {
    //     case 'done':
    //       this.onProductCreateDone(state.createNewProductProcess.lastCreatedProduct);
    //       break;
    //     case 'error':
    //       this.onProductCreateError(state.createNewProductProcess.error)
    //       break;
    //     default:
    //       break;
    //   }

    // })
  };
}
